module.exports = __webpack_public_path__ + "static/media/BannerRankingDesktop.9185bf96.webp";